module.exports = __webpack_public_path__ + "media/images/lp/history3-sp-53c238d06fdd037d9bac5ee47a8f6f18.jpg";